module.exports = __webpack_public_path__ + "static/media/effect.2112debe.jpg";